import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'ordersAwaitingConfirm';
export const ordersAwaitingConfirmActions = makeActions(
  MODEL_NAME,
  'id',
  'orders',
);

export const getAllOrdersAwaitingConfirm = ordersAwaitingConfirmActions.getAll;
export const editOrdersAwaitingConfirm = ordersAwaitingConfirmActions.edit;
export const createOrdersAwaitingConfirm = ordersAwaitingConfirmActions.create;
export const getByIdOrdersAwaitingConfirm =
  ordersAwaitingConfirmActions.getDataById;
